// Don't use directly - import { Link } from '@tracklib/kit' instead

import { Link as RouterLink, NavLink as RouterNavLink } from 'react-router-dom'
import { stringify } from 'querystringify'

// Components
import ModalLink from 'components/modal/link/link'

type LinkProps = {
  activeClassName?: string
  ariaLabel?: string
  children: JSX.Element | string
  className?: string
  datatesting?: string
  id?: string
  modal?: boolean
  onClick?: (arg0: unknown) => unknown
  query?: Record<string, unknown> | null | undefined
  title?: string
  to?: string
}

const Link = (props: LinkProps): JSX.Element => {
  const { to, children, modal, onClick, className, datatesting, id, title } = props
  const { ariaLabel, query, activeClassName = '', ...propsWithoutExcluded } = props // get all props except ariaLabel and query (for spread below)

  if (!to && !query) {
    return (
      <a {...propsWithoutExcluded} aria-label={ariaLabel}>
        {children}
      </a>
    )
  }

  if (modal && to) {
    return (
      <ModalLink
        modal={to}
        onClick={onClick}
        className={className}
        extraQuery={query}
        datatesting={datatesting}
        id={id}
        title={title}
        ariaLabel={ariaLabel}
      >
        {children}
      </ModalLink>
    )
  }

  const parsedToObject = (query ? { pathname: to, search: stringify(query) } : to) || ''

  if (activeClassName) {
    return (
      <RouterNavLink {...propsWithoutExcluded} activeClassName={activeClassName} to={parsedToObject} aria-label={ariaLabel}>
        {children}
      </RouterNavLink>
    )
  }
  return <RouterLink {...propsWithoutExcluded} to={parsedToObject} aria-label={ariaLabel} />
}

export default Link
